import React, { useMemo } from 'react'
import { defineMessages, FormattedMessage, MessageDescriptor } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { ClientFiltersCheckboxSection } from './ClientFiltersCheckboxSection'
import { BodyText } from '../../../atoms/bodyText/BodyText'

export enum NextSession {
  SCHEDULED = 'SCHEDULED',
  UNSCHEDULED_LESS_30_DAYS = 'UNSCHEDULED_LESS_30_DAYS',
  UNSCHEDULED_MORE_30_DAYS = 'UNSCHEDULED_MORE_30_DAYS',
}

export type ClientFiltersNextSessionSectionProps = {
  values: NextSession[]
  onChange: (values: NextSession[]) => void
}

export const ClientFiltersNextSessionSection: React.FC<ClientFiltersNextSessionSectionProps> = ({
  values,
  onChange,
}) => {
  const theme = useTheme()
  const filterNames: Record<NextSession, MessageDescriptor> = useMemo(
    () =>
      defineMessages({
        [NextSession.SCHEDULED]: {
          defaultMessage: 'Scheduled',
          description: 'Label for filtering conversations by active',
        },
        [NextSession.UNSCHEDULED_LESS_30_DAYS]: {
          defaultMessage: 'Unscheduled <secondary>(less than 30 days)</secondary>',
          description: 'Label for filtering conversations by unread',
          values: {
            secondary: (chunks: string) => <BodyText color={theme.colors.textSecondary} text={chunks} />,
          },
        },
        [NextSession.UNSCHEDULED_MORE_30_DAYS]: {
          defaultMessage: 'Unscheduled <secondary>(more than 30 days)</secondary>',
          description: 'Label for filtering conversations by unscheduled',
          values: {
            secondary: (chunks: string) => <BodyText color={theme.colors.textSecondary} text={chunks} />,
          },
        },
      }),
    [theme],
  )

  return (
    <ClientFiltersCheckboxSection
      title={<FormattedMessage defaultMessage='Next session' description='Next session filter section' />}
      items={Object.values(NextSession).map((value) => ({
        id: value,
        text: <FormattedMessage {...filterNames[value]} />,
      }))}
      values={values}
      onChange={onChange}
      name='nextSession'
    />
  )
}
